export * from '@yandex-int/hr-components/Button/desktop/bundle';
